module.exports = __webpack_public_path__ + "img/neotag_unit_purple-01.99eea1da.svg";